<script setup>
defineProps({
  title: { type: String, required: true },
  // 标题下最多一行的提示；超出截断，全文放 title。
  hint: { type: String, default: '' },
})
</script>

<template>
  <section class="au-card">
    <header class="au-card__head">
      <h2 class="au-card__title">{{ title }}</h2>
      <div v-if="$slots.meta" class="au-card__meta"><slot name="meta" /></div>
    </header>
    <p v-if="hint" class="au-hint" :title="hint">{{ hint }}</p>
    <slot />
  </section>
</template>
